export enum CustomRoleStepperSteps {
  RoleDetailsStep = 'role_details_step',
  PermissionDetailsStep = 'permission_details_step',
  CapabilityDetailsStep = 'capability_details_step',
  SummaryStep = 'summary_step',
}

export enum ChangeStatusTypes {
  NoChange = 'no_change',
  Added = 'added',
  Deleted = 'deleted',
}
